import { ErpClaimCode } from '../../../shared/models/erp-claim-code.enum';
import { claimIsActive } from '../../../shared/services/claims.service';

export const htmlId: string = 'document-list-view';

// NER-10125: only users who hold CUSTOMER_VIEW_ALL_ORDERS_ROLE get the Buyer contact and Order method columns, and only on the order list.
export const shouldShowOrderInfoColumns = (isClientOrderList: boolean, claims: string[] | null | undefined): boolean =>
    isClientOrderList && claimIsActive(claims, ErpClaimCode.CUSTOMER_VIEW_ALL_ORDERS_ROLE);
